function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.2417 16.3689L19.1166 3.24379C18.8981 3.0854 18.6021 3.0854 18.3836 3.24379L0.258485 16.3689C0.0961309 16.4864 0 16.6746 0 16.8751V39.3753C0 39.7204 0.279848 40.0003 0.625003 40.0003H36.8752C37.2203 40.0003 37.5002 39.7204 37.5002 39.3753V16.8751C37.5002 16.6746 37.4041 16.4864 37.2417 16.3689Z",
  fill: "#033AA4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.1252 0H4.375C4.02985 0 3.75 0.279848 3.75 0.625003V36.2502C3.75 36.5953 4.02985 36.8752 4.375 36.8752H33.1252C33.4703 36.8752 33.7502 36.5953 33.7502 36.2502V0.625003C33.7502 0.279848 33.4703 0 33.1252 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7501 8.12501H11.25C10.9048 8.12501 10.625 7.84516 10.625 7.5C10.625 7.15485 10.9048 6.875 11.25 6.875H28.7501C29.0952 6.875 29.3751 7.15485 29.3751 7.5C29.3751 7.84516 29.0952 8.12501 28.7501 8.12501Z",
  fill: "#D5D8DE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 13.125H8.75C8.40485 13.125 8.125 12.8452 8.125 12.5C8.125 12.1548 8.40485 11.875 8.75 11.875H20.0001C20.3452 11.875 20.6251 12.1548 20.6251 12.5C20.6251 12.8452 20.3452 13.125 20.0001 13.125Z",
  fill: "#D5D8DE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 18.125H8.75C8.40485 18.125 8.125 17.8452 8.125 17.5C8.125 17.1548 8.40485 16.875 8.75 16.875H13.75C14.0952 16.875 14.375 17.1548 14.375 17.5C14.375 17.8452 14.0952 18.125 13.75 18.125Z",
  fill: "#D5D8DE"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2501 18.125H16.25C15.9048 18.125 15.625 17.8452 15.625 17.5C15.625 17.1548 15.9048 16.875 16.25 16.875H26.2501C26.5952 16.875 26.8751 17.1548 26.8751 17.5C26.8751 17.8452 26.5952 18.125 26.2501 18.125Z",
  fill: "#D5D8DE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.25 13.125H22.5C22.1548 13.125 21.875 12.8452 21.875 12.5C21.875 12.1548 22.1548 11.875 22.5 11.875H26.25C26.5952 11.875 26.875 12.1548 26.875 12.5C26.875 12.8452 26.5952 13.125 26.25 13.125Z",
  fill: "#D5D8DE"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M4.375 36.8743H33.1252C33.4703 36.8743 33.7502 36.5945 33.7502 36.2493V16.457L18.7501 24.7328L3.75 16.457V36.2493C3.75 36.5945 4.02985 36.8743 4.375 36.8743Z",
  fill: "#EAEBEF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.1929 16.3367C37.0024 16.2244 36.7669 16.221 36.5734 16.3278L18.7501 26.1612L0.926824 16.3278C0.733341 16.221 0.497744 16.2244 0.307314 16.3367C0.116883 16.4493 0 16.6537 0 16.875V39.3751C0 39.7203 0.279848 40.0001 0.625003 40.0001H36.8752C37.2203 40.0001 37.5002 39.7203 37.5002 39.3751V16.875C37.5002 16.6537 37.3833 16.4493 37.1929 16.3367Z",
  fill: "#0041BE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8752 39.9996C37.2203 39.9996 37.5002 39.7197 37.5002 39.3746V35.5831L23.1691 23.7227L18.7501 26.1607L14.3311 23.7227L0 35.5831V39.3746C0 39.7197 0.279848 39.9996 0.625003 39.9996H36.8752Z",
  fill: "#033AA4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2738 37.0186L19.1487 22.0185C18.9173 21.8272 18.5829 21.8272 18.3515 22.0185L0.226442 37.0186C0.0830082 37.1373 0 37.314 0 37.5002V39.3752C0 39.7203 0.279848 40.0002 0.625003 40.0002H36.8752C37.2203 40.0002 37.5002 39.7203 37.5002 39.3752V37.5002C37.5002 37.314 37.4172 37.1373 37.2738 37.0186Z",
  fill: "#0041BE"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M33.125 4.375C30.0235 4.375 27.5 6.89851 27.5 10C27.5 13.1015 30.0235 15.6251 33.125 15.6251C36.2265 15.6251 38.7501 13.1015 38.7501 10C38.7501 6.89851 36.2265 4.375 33.125 4.375Z",
  fill: "#FF5C53"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M35 14.3753C31.8985 14.3753 29.375 11.8518 29.375 8.75026C29.375 7.20668 30.0003 5.80652 31.0105 4.78906C28.9539 5.62677 27.5 7.64644 27.5 10.0003C27.5 13.1018 30.0235 15.6253 33.125 15.6253C34.683 15.6253 36.095 14.9884 37.1146 13.9615C36.4612 14.2273 35.7477 14.3753 35 14.3753Z",
  fill: "#E24D4D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M33.25 13C32.8358 13 32.5 12.6642 32.5 12.25V9.56064L32.2803 9.78036C31.9873 10.0733 31.5127 10.0733 31.2197 9.78036C30.9268 9.4874 30.9268 9.0128 31.2197 8.71984L32.7197 7.21989C32.9343 7.00529 33.257 6.94084 33.5371 7.05729C33.8173 7.17338 34 7.44693 34 7.75014V12.25C34 12.6642 33.6642 13 33.25 13Z",
  fill: "#F4F5F7"
});

function SvgReset2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset2);
export default __webpack_public_path__ + "static/media/reset2.bdd73f59.svg";
export { ForwardRef as ReactComponent };